"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionNominalResults = void 0;
const adaptivecards_1 = require("adaptivecards");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const ChoiceResultRow_1 = require("../components/ChoiceResultRow");
const surveyHelpers_1 = require("../utils/surveyHelpers");
const surveyHelpers_2 = require("../utils/surveyHelpers");
const QuestionNominalResults = (surveyResponses, question, anonymityLevel, hideSummaryTitle, applicationType, maxChoiceCount, currentUserId) => {
    const container = CardHelper_1.CardHelper.create(adaptivecards_1.Container, { separator: true });
    const questionResponses = (0, surveyHelpers_1.getQuestionResponses)(surveyResponses, question.id);
    let totalVotes = 0;
    let choiceList = question.choices.map(choice => {
        const votes = questionResponses
            .filter(r => {
            return Array.isArray(r.response.value)
                ? r.response.value.indexOf(choice.id) > -1
                : r.response.value === choice.id;
        })
            .sort(surveyHelpers_2.questionResponseSort);
        totalVotes += votes.length;
        const currentUserPosition = votes.findIndex(v => { var _a; return ((_a = v.user) === null || _a === void 0 ? void 0 : _a.aadObjectId) === currentUserId; });
        if (currentUserPosition > 0) {
            //Always put the current user at the front so their name displays
            const temp = votes[0];
            votes[0] = votes[currentUserPosition];
            votes[currentUserPosition] = temp;
        }
        return {
            choice,
            votes: votes.length,
            users: votes.map(v => v.user.name),
            isUserVote: currentUserPosition !== -1,
        };
    });
    if (maxChoiceCount !== undefined && choiceList.length > maxChoiceCount) {
        const votedChoices = choiceList.filter(c => c.votes).sort((a, b) => b.votes - a.votes);
        if (votedChoices.length >= maxChoiceCount) {
            choiceList = votedChoices.slice(0, maxChoiceCount);
        }
        else {
            const noVotes = choiceList.filter(c => c.votes === 0);
            choiceList = votedChoices.concat(noVotes.slice(0, maxChoiceCount - votedChoices.length));
        }
    }
    choiceList.forEach(choiceResult => {
        container.addItem((0, ChoiceResultRow_1.ChoiceResultRow)(choiceResult.choice.value, choiceResult.votes, totalVotes, choiceResult.users, anonymityLevel, applicationType, maxChoiceCount !== undefined, choiceResult.isUserVote));
    });
    if (!hideSummaryTitle) {
        container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            text: `Total Votes: ${totalVotes}`,
            weight: adaptivecards_1.TextWeight.Bolder,
            separator: true,
            spacing: adaptivecards_1.Spacing.Large,
        }));
    }
    return container;
};
exports.QuestionNominalResults = QuestionNominalResults;
//# sourceMappingURL=QuestionNominalResults.js.map